import { IconProps } from "@/components/Icons/index";

export const AuthLogo: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/ioid.png" alt="ioid" {...props} />;
};
